import { ActionTypes } from "../constants/action-type";

export const setSelectAllAction = (products) => {
  return { type: ActionTypes.SELECT_ALL, payload: products };
};


